<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="专家信息变更" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-spin :spinning="loading">
                <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="padding:10px 20px;">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="变更单编号">
                                <a-input ref="bgdbh" v-model="editData.bgdbh" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="变更日期" required>
                                <a-date-picker ref="bgrq" v-model="editData.bgrq" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专家姓名" required>
                                <a-input-search ref="zjxm2" readOnly @search="isShow_zjxm2 = true" v-model="editData.zjxm2" />
                                <FGDataSelect
                                    :isShow.sync="isShow_zjxm2"
                                    selectNo="ZJ1001"
                                    :condition="' AND DWMC = \'' + getUserInfo.companyInfo.dwmc + '\' '"
                                    @saveselect="saveEvent_zjxm2(arguments, editData)"
                                ></FGDataSelect>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="单位名称" required>
                                <a-input ref="dwmc2" disabled v-model="editData.dwmc2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专业一">
                                <a-input-search ref="zymc2" disabled @search="isShow_zymc2 = true" v-model="editData.zymc2" />
                                <FGDataSelect :isShow.sync="isShow_zymc2" selectNo="RY200601" @saveselect="saveEvent_zymc2(arguments, editData)"></FGDataSelect>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="子专业一">
                                <a-input ref="zzymc2" disabled v-model="editData.zzymc2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专业二">
                                <a-input-search ref="zymc1_bf" disabled v-model="editData.zymc1_bf" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="子专业二">
                                <a-input ref="zzymc1_bf" disabled v-model="editData.zzymc1_bf" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="性别" required>
                                <FGDictSelectCN ref="xb2" dictNo="RY100101" v-model="editData.xb2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="职务">
                                <a-input ref="zw2" v-model="editData.zw2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="职称">
                                <a-input ref="zc2" v-model="editData.zc2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="身份证号" required>
                                <a-input ref="zjhm2" v-model="editData.zjhm2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="手机号" required>
                                <a-input ref="sjhm2" v-model="editData.sjhm2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="通讯地址">
                                <a-input ref="txdz2" v-model="editData.txdz2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="毕业院校">
                                <a-input ref="byyx2" v-model="editData.byyx2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="学位">
                                <a-input ref="xw2" v-model="editData.xw2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="毕业时间">
                                <a-date-picker ref="bysj2" v-model="editData.bysj2" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="学历专业">
                                <a-input ref="xlzymc2" v-model="editData.xlzymc2" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="工作业绩" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="gzyj2" v-model="editData.gzyj2" :rows="3" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="担任外系统评委情况" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="drwxtpwqk2" v-model="editData.drwxtpwqk2" :rows="3" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="工作简介" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="gzjj2" v-model="editData.gzjj2" :rows="3" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="用户名" required>
                                <a-input-search
                                    ref="yhm2"
                                    v-model="editData.yhm2"
                                    @search="checkUsername"
                                    @change="
                                        () => {
                                            usernameFlag.type = false;
                                        }
                                    "
                                >
                                    <a-button slot="enterButton">
                                        用户名检测
                                    </a-button>
                                </a-input-search>
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="录入人">
                                <a-input ref="lrr" v-model="editData.lrr" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="录入日期">
                                <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="备注">
                                <a-input ref="bz" v-model="editData.bz" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="变更类型" required>
                                <FGDictSelectCN ref="bglx" dictNo="ZJ200101" v-model="editData.bglx" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-spin>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "ZjxxbglrEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 培训记录明细数据
            editItemData: [],
            editItemDataLoading: false,
            isShow_zjxm2: false,
            isShow_dwmc2: false,
            isShow_zymc2: false,
            usernameFlag: {
                type: false
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading || this.editItemDataLoading;
        }
    },
    created() {},
    activated() {
        this.usernameFlag.type = false;
        if (!this.editDataId) {
            this.$FG_helper.handleNewBillCode("BGDBH").then((val) => {
                // 新增，设置默认值
                this.editData = {
                    id: this.$FG_util.uuid(),
                    isnew: true,
                    bgdbh: val,
                    bgrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                    djlxid: "ZJXXBG",
                    bmid: this.getUserInfo.org_id,
                    ryid: this.getUserInfo.personnel_id,
                    yhid: this.getUserInfo.id,
                    lrr: this.getUserInfo.personnel_name,
                    lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                    djzt: "制定",
                    bglx: "一般"
                };
                this.tableData = [];
                this.submitShow = false;
            });
        } else {
            this.submitShow = true;
            // 修改，加载数据
            this.loadData();
            this.isnew = false;
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.bgdbh.focus();
        });
    },
    methods: {
        checkUsername() {
            this.$FG_http
                .post(
                    "./api/admin/user/checkChange",
                    {
                        zjid: this.editData.zjid,
                        username: this.editData.yhm2
                    },
                    { showSuccess: false }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.usernameFlag.type = data.data;
                        if (data.data) {
                            this.$FG_message.warn("当前用户名可用！").then(() => this.$refs.yhm2.focus());
                        } else {
                            this.$FG_message.error("当前用户名已被注册！").then(() => this.$refs.yhm2.focus());
                        }
                    } else {
                        this.$refs.yhm2.focus();
                    }
                });
        },
        saveEvent_zjxm2(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.zjid = val[0][0].ID;
                this.editData.zjxm2 = val[0][0].ZJXM;
                this.editData.dwmc2 = val[0][0].DWMC;
                this.editData.zyid2 = val[0][0].ZYID;
                this.editData.zymc2 = val[0][0].ZYMC;
                this.editData.zzymc2 = val[0][0].ZZYMC;
                this.editData.xb2 = val[0][0].XB;
                this.editData.zw2 = val[0][0].ZW;
                this.editData.zc2 = val[0][0].ZC;
                this.editData.zjhm2 = val[0][0].ZJHM;
                this.editData.sjhm2 = val[0][0].SJHM;
                this.editData.txdz2 = val[0][0].TXDZ;
                this.editData.byyx2 = val[0][0].BYYX;
                this.editData.xw2 = val[0][0].XW;
                this.editData.bysj2 = val[0][0].BYSJ;
                this.editData.xlzymc2 = val[0][0].XLZYMC;
                this.editData.gzyj2 = val[0][0].GZYJ;
                this.editData.drwxtpwqk2 = val[0][0].DRWXTPWQK;
                this.editData.gzjj2 = val[0][0].GZJJ;
                this.editData.yhm2 = val[0][0].YHM;
                this.editData.dwmc = val[0][0].DWMC;
                this.editData.zjxm = val[0][0].ZJXM;
                this.editData.zyid = val[0][0].ZYID;
                this.editData.zymc = val[0][0].ZYMC;
                this.editData.zzymc = val[0][0].ZZYMC;
                this.editData.zyid1 = val[0][0].ZYID1;
                this.editData.zymc1 = val[0][0].ZYMC1;
                this.editData.zzymc1 = val[0][0].ZZYMC1;
                this.editData.zyid1_bf = val[0][0].ZYID1;
                this.editData.zymc1_bf = val[0][0].ZYMC1;
                this.editData.zzymc1_bf = val[0][0].ZZYMC1;
                this.editData.xb = val[0][0].XB;
                this.editData.zw = val[0][0].ZW;
                this.editData.zc = val[0][0].ZC;
                this.editData.zjhm = val[0][0].ZJHM;
                this.editData.sjhm = val[0][0].SJHM;
                this.editData.txdz = val[0][0].TXDZ;
                this.editData.byyx = val[0][0].BYYX;
                this.editData.xw = val[0][0].XW;
                this.editData.bysj = val[0][0].BYSJ;
                this.editData.xlzymc = val[0][0].XLZYMC;
                this.editData.gzyj = val[0][0].GZYJ;
                this.editData.drwxtpwqk = val[0][0].DRWXTPWQK;
                this.editData.gzjj = val[0][0].GZJJ;
                this.editData.yhm = val[0][0].YHM;
                this.editData.zjzt = val[0][0].ZJZT;
            }
        },
        saveEvent_dwmc2(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.dwmc2 = val[0][0].DWMC;
            }
        },
        saveEvent_zymc2(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.zyid2 = val[0][0].ID;
                this.editData.zymc2 = val[0][0].ZYMC;
            }
        },
        //提交form
        onSave(btnType) {
            // 表单校验
            if (btnType === 1) {
                if (!this.usernameFlag.type) {
                    this.$FG_message.error("请先完成用户名检测!").then(() => this.$refs.yhm2.focus());
                    return;
                }
                if (!this.editData.bgrq) {
                    this.$FG_message.error("P0001", "变更日期").then(() => this.$refs.bgrq.focus());
                    return;
                }
                if (!this.editData.zjxm2) {
                    this.$FG_message.error("P0001", "专家姓名").then(() => this.$refs.zjxm2.focus());
                    return;
                }
                if (!this.editData.dwmc2) {
                    this.$FG_message.error("P0001", "单位名称").then(() => this.$refs.dwmc2.focus());
                    return;
                }
                if (!this.editData.zymc2) {
                    this.$FG_message.error("P0001", "专业").then(() => this.$refs.zymc2.focus());
                    return;
                }
                if (!this.editData.xb2) {
                    this.$FG_message.error("P0001", "性别").then(() => this.$refs.xb2.focus());
                    return;
                }
                if (!this.editData.zjhm2) {
                    this.$FG_message.error("P0001", "身份证号").then(() => this.$refs.zjhm2.focus());
                    return;
                }
                if (!this.editData.sjhm2) {
                    this.$FG_message.error("P0001", "手机号").then(() => this.$refs.sjhm2.focus());
                    return;
                }
                if (!this.editData.yhm2) {
                    this.$FG_message.error("P0001", "用户名").then(() => this.$refs.yhm2.focus());
                    return;
                }
                if (!this.editData.bglx) {
                    this.$FG_message.error("P0001", "变更类型").then(() => this.$refs.bglx.focus());
                    return;
                }
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/zjxxbg/save",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        if (btnType === 1) {
                            this.submit();
                        }
                    } else {
                        this.$refs.bgdbh.focus();
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/zjxx/zjxxbg/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.bgdbh.focus();
                            }
                        });
                }
            });
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zjxx/zjxxbg/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        }
    }
};
</script>
